import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpsi4sr7: FaireProductEntity = {
  token: "p_cpsi4sr7",
  type: "product",
  name: "Ocean of Thanks Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5cb52de2bd8ff0b6faf255ee7680892f7d4fe709c68f863b68122fc24aed3d9b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d943ab12accd7f84cc3d0191a60710dbbe73a8095154875e6826846235c791f6/1528385827.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8fa0d3e74626e14636c367a71e4002e4ca3b56028695934eca60ace7196e2ae8/1528385841.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:57.510Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
